<template>
    <div>
        <b-card body-class="pt-0 p-3">
            <template v-slot:header>
                <b-row>
                    <b-col>
                        <h1 class="m-0">Search</h1>
                    </b-col>
                    <b-col class="d-flex justify-content-end align-items-center">
                        <b-button class="float-right align-baseline" v-b-modal.modal-create-new-order>
                            <i class="fa-solid fa-plus mr-1"></i>Create New Customer with Order
                        </b-button>
                    </b-col>
                </b-row>
            </template>


            <!--*****************-->
            <!--***** Filters *****-->
            <!--*****************-->
            <b-form-row class="mb-4">
                <b-col cols="3">
                    <b-card class="mb-0 h-100" body-class="p-2">
                        <template v-slot:header>
                            <b-form-row>
                                <b-col><span class="h4 mb-0"><i class="fa-solid fa-filter"></i> Field Filters</span></b-col>
                                <b-col cols="5">
                                    <b-form-select size="sm"
                                                   v-model="filterGroupSelected"
                                                   :options="filterGroups">
                                    </b-form-select>
                                </b-col>
                            </b-form-row>
                        </template>

                        <loading-spinner :busy="loadingFilter"></loading-spinner>
                        <b-form-select
                            v-if="!loadingFilter"
                            ref="filterSelectList"
                            v-model="filterSelected"
                            :options="_setFilterOptions"
                            :select-size="12">
                        </b-form-select>
                    </b-card>
                </b-col>
                <b-col cols="6">
                    <b-card class="mb-0" header="Active Filters" body-class="active-filters-height">
                        <template v-slot:header>
                            <b-row>
                                <b-col>
                                    <div class="d-flex align-items-center">
                                        <span class="h4 mb-0"><i class="fa-solid fa-th-list"></i> Active Filters</span>
                                    </div>
                                </b-col>
                                <b-col class="text-right">
                                    <b-button @click="refreshData()" variant="info" size="sm"
                                              class="mr-2 font-weight-bold">
                                        <i :class="table.refresh ? 'fa-spin' : '' " class="fa-solid fa-sync-alt mr-2"></i>
                                        Refresh
                                    </b-button>
                                    <b-button @click="clearFilters" variant="warning" size="sm"
                                              class="ml-2 font-weight-bold"><i class="fa-solid fa-eraser mr-2"></i>Clear
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>
                        <loading-spinner :busy="loadingFilter"></loading-spinner>
                        <template v-for="(item,index) in masterQuery" v-if="!loadingFilter">
                            <SearchFilterItem
                                :key="index"
                                :index="index"
                                :item="item"
                                :masterQuery="masterQuery"
                                :itemClasses="itemClasses"
                                :flagTypes="flagTypes"
                                :itemTypes="itemTypes"
                                :inventoryTypes="inventoryTypes"
                                :itemClarities="itemClarities"
                                :users="users"

                                :loadSavedFilter="loadSavedFilter"
                                v-on:updateFilter="updateFilter"
                                v-on:removeFilter="removeFilter">
                            </SearchFilterItem>
                        </template>

                    </b-card>
                </b-col>
                <b-col>
                    <b-card class="mb-0 h-100" body-class="active-filters-height">
                        <template v-slot:header>
                            <b-row>
                                <b-col>
                                    <div class="d-flex align-items-center">
                                        <span class="h4 mb-0"><i class="fa-solid fa-th-list"></i> Saved Filters</span>
                                    </div>
                                </b-col>
                                <b-col cols="4" class="text-right">
                                    <b-button @click="openSaveFilterModal"
                                              size="sm"
                                              class="mr-2 font-weight-bold"
                                              :disabled="loadingFilter"
                                              variant="info">
                                        <i class="fa-regular fa-plus"></i> New
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>

                        <!--saved filters-->
                        <loading-spinner :busy="loadingFilter"></loading-spinner>
                        <div v-for="(value, index, sysIndex) in customFilters" :key="sysIndex">
                            <b-card @click="loadCustomFilter(value)" body-class="p-2" class="pointer bg-light mb-2">
                                <span class="float-left text-primary font-weight-bold">{{ value.name }}</span>
                                <span @click="openDeleteFilterModal(index)" class="float-right"
                                      v-if="value.global == 0"><i
                                    class="fa-solid fa-times text-danger"></i></span>
                            </b-card>
                        </div>

                    </b-card>
                </b-col>
            </b-form-row>


            <!--*****************-->
            <!--***** Table *****-->
            <!--*****************-->
            <div class="bg-light p-3">
                <b-row v-if="findFilterByName('Offer Email Sent').length != 0" class="pb-2">
                    <b-col>
                        <b-button :disabled="sendingEmail" @click="sendEmail" variant="info"><i v-if="sendingEmail"
                                                                                                class="fa-regular fa-spin fa-spinner"></i><i
                            v-else class="fa-regular fa-envelope"></i> Send Offer Ready Email
                        </b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <span class="h4 mb-0">Search Results: <small class="text-muted">( {{ _itemRangeShown.start }} - {{
                                _itemRangeShown.end
                            }} of {{ table.itemsTotal }} )</small></span>
                    </b-col>
                    <b-col>
                        <div class="d-flex">
                            <b-button @click="prevPage">Prev</b-button>
                            <div style="max-width: 100px">
                                <b-card class="mb-0 h-100"
                                        style="min-width: 100px"
                                        body-class="py-1 px-3 text-center">
                                    {{ table.currentPage }} - {{ _lastPage }}
                                </b-card>
                            </div>

                            <b-button @click="nextPage">Next</b-button>
                        </div>
                    </b-col>

                    <b-col cols="2">
                        <div class="d-flex align-items-center">
                            <span class="mr-2">Limit: </span>
                            <b-form-select class="w-50" :options="[10, 30]"
                                           v-model="table.perPage"></b-form-select>
                        </div>

                    </b-col>
                    <b-col cols="2">
                        <div class="d-flex align-items-center">
                            <span class="mr-2">View: </span>
                            <b-form-select :options="['simple', 'full']" v-model="table.tableView"></b-form-select>
                        </div>
                    </b-col>
                    <b-col cols="2">
                        <div class="text-right">
                            <b-button :disabled="downloadingCSV" @click="download" variant="info"><i
                                v-if="downloadingCSV" class="fa-regular fa-spin fa-spinner"></i><i v-else
                                                                                           class="fa-solid fa-file-export"></i>
                                Export to Excel
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table class="text-center"
                     head-variant="dark"
                     hover
                     striped
                     bordered
                     selectable
                     ref="resultsTable"
                     @row-selected="onRowSelected"
                     selected-variant="success"
                     :busy="table.isBusy"
                     :per-page="table.perPage"
                     :current-page="table.currentPage"
                     :items="items"
                     :fields="_tableFields"
                     show-empty>
                <template v-slot:head(selected)="row">
                    <template v-if="table.allRowsSelected">
                        <i class="fa-regular fa-check-square fa-fw" @click="clearSelected"></i>
                    </template>
                    <template v-else>
                        <i class="fa-regular fa-square fa-fw" @click="selectAllRows"></i>
                    </template>
                </template>
                <template v-slot:head()="data">
                    {{ data.label | titleCase }}
                </template>


                <template v-slot:cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                        <i class="fa-regular fa-check-square fa-fw"></i>
                    </template>
                    <template v-else>
                        <i class="fa-regular fa-square fa-fw"></i>
                    </template>
                </template>

                <template v-slot:cell(select)="data">
                    {{ data }}
                    <i class="fa-solid fa-square"></i></template>

                <template v-slot:cell(name)="data">{{ data.item.customer.full_name | titleCase }}
                </template>
                <template v-slot:cell(id)="data"><a :href="`/kit/view/${data.item.id}`"
                                                    @click.prevent="goToKitsView(data.item.id)">{{ data.item.id }}</a>
                </template>
                <template v-slot:cell(customer_id)="data"><a :href="`/kit/view/${data.item.id}`"
                                                             @click.prevent="goToKitsView(data.item.id)">{{
                        data.item.customer.id
                    }}</a></template>


                <template v-slot:cell(outbound_method)="data">
                    <i v-b-tooltip.hover
                       :title="data.item.current_lead ? data.item.current_lead.fulfillment_method : 'N/A' "
                       class="fas"
                       :class="
                            data.item.current_lead
                                ? (
                                   data.item.current_lead.fulfillment_method == 'email' ? 'fa-inbox-in': (
                                       data.item.current_lead.fulfillment_method == 'print' ? 'fa-print': 'fa-envelope'
                                   )
                                )
                                : 'fa-envelope'
                        "
                    ></i>
                </template>
                <template v-slot:cell(api_client)="data">{{ data.item.brand.name }}</template>

                <template v-slot:cell(location)="data">
                    <span v-if="data.item.customer.address">
                        {{ data.item.customer.address.city }}, {{ data.item.customer.address.state }}
                    </span>
                </template>

                <template v-slot:cell(created_at)="data">{{ data.item.created_at | datetimeNoTZ }}</template>
                <template v-slot:cell(received_at)="data">{{ data.item.received_at | datetimeNoTZ }}</template>
                <template v-slot:cell(appraised_at)="data">{{ data.item.appraised_at | datetimeNoTZ }}</template>
                <template v-slot:cell(updated_at)="data">{{ data.item.updated_at | datetimeNoTZ }}</template>


                <!--update-->
                <template v-slot:cell(campaign)="data"><i>{{ data.item.order_source ? data.item.order_source.campaign_name || "N/A" : "N/A"}}</i></template>

                <template v-slot:cell(total_value)="data"><span><span v-if="data.value == 'N\A'">N/A</span><span v-else>${{ data.value | toFixed2 }}</span></span></template>
                <template v-slot:cell(total_offer)="data"><span><span v-if="data.value == 'N\A'">N/A</span><span v-else>${{ data.value | toFixed2 }}</span></span></template>

                <template v-slot:cell(total_orders)="data">{{ data.item.customer.orders_count }}</template>


                <template v-slot:table-busy>
                    <LoadingSpinner :busy="table.isBusy"/>
                </template>

            </b-table>
            <!--*****************-->
            <!--***** End Table *****-->
            <!--*****************-->


        </b-card>

        <b-modal id="saveFilterModal"
                 ref="saveFilterModal"
                 ok-title="Save Filter"
                 title="Save Filter">
            <h5 class="my-4 text-center">Please enter a name to associate to this result view:</h5>
            <b-input ref="customFilterInput" class="mb-2 text-center" type="text" v-model="customFilterName"></b-input>
            <div class="text-center">
                <b-button :disabled="!customFilterName" size="lg" variant="primary" @click="saveCustomFilters">
                    Save Filter
                </b-button>
            </div>

            <template #modal-footer="{ cancel }">
                <b-button size="sm" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>

        <b-modal id="deleteFilterModal"
                 ref="deleteFilterModal"
                 ok-title="Delete Saved Filter"
                 title="Delete Saved Filter">
            <h5 class="my-4 text-center">Are you sure you want to delete the saved filter<br>
                <mark>
                    {{ customFilters && customFilters[customFilterToDelete] && customFilters[customFilterToDelete].name ? customFilters[customFilterToDelete].name : null }}
                </mark>
            </h5>
            <div class="text-center">
                <b-button size="lg" variant="danger" @click="deleteCustomFilter(customFilterToDelete)">
                    Delete Filter
                </b-button>
            </div>

            <template #modal-footer="{ cancel }">
                <b-button size="sm" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>

        <CreateNewCustomerModal></CreateNewCustomerModal>

    </div>
</template>

<script>
import SearchFilterItem from './SearchFilterItem';
import LoadingSpinner from '@/components/LoadingSpinner';
import CreateNewCustomerModal from '@/components/CreateNewCustomer';
import _ from 'lodash';

export default {
    name: 'search-index',
    title: 'Search',
    components: {
        CreateNewCustomerModal,
        SearchFilterItem,
        LoadingSpinner
    },
    data() {
        return {
            sendingEmail: false,
            selected: [],
            cancelToken: undefined,
            metalTypes: null,
            inventoryTypes: null,
            flagTypes: null,
            itemTypes: null,
            itemClarities: null,
            itemClasses: null,
            users: null,
            orders: null,
            downloadingCSV: false,

            loadingFilter: true,
            loadingConfig: 0,
            loadSavedFilter: false,
            items: [],
            hrefQueryPayload: null,
            masterQuery: [
                {
                    filterModel: 'order',
                    filterField: 'status_id',
                    filterName: 'Order Status',
                    filterValue: 1,
                    filterParameter: 'equals'
                },
            ],
            baseFilters: [
                {
                    filterModel: 'customer',
                    filterField: 'first_name',
                    filterName: 'First Name',
                    filterValue: null,
                    filterParameter: 'contains'
                },
                {
                    filterModel: 'customer',
                    filterField: 'last_name',
                    filterName: 'Last Name',
                    filterValue: null,
                    filterParameter: 'equals'
                },
                {
                    filterModel: 'customer',
                    filterField: 'email',
                    filterName: 'Email Address',
                    filterValue: null,
                    filterParameter: 'equals'
                },
                {
                    filterModel: 'customer',
                    filterField: 'phone',
                    filterName: 'Phone Number',
                    filterValue: null,
                    filterParameter: 'equals'
                },
                {
                    filterModel: 'order',
                    filterField: 'status_id',
                    filterName: 'Order Status',
                    filterValue: 1,
                    filterParameter: 'equals'
                },
            ],
            customFilterName: null,
            customFilters: [],
            customFilterToDelete: null,
            filterSelected: null,
            filterGroupSelected: 1,
            filterGroups: [
                {value: 1, text: 'Orders'},
                {value: 2, text: 'Customer'},
                {value: 3, text: 'Inventory'},
                {value: 4, text: 'Returns'}
            ],
            filterList: {
                orders: [
                    {value: {name: 'Brand', model: 'order', field: 'brand_id'}, text: 'Brand'},
                    {value: {name: 'Accept Date', model: 'pseudo_accepted_at', field: 'offers.decided_at'}, text: 'Accept Date'},
                    {value: {name: 'Decline Date', model: 'pseudo_declined_at', field: 'offers.decided_at'}, text: 'Decline Date'},
                    {value: {name: 'Accept Method', model: 'order.offers', field: 'accept_method'}, text: 'Accept Method'},
                    {value: {name: 'Appraisal Date', model: 'order', field: 'appraised_at'}, text: 'Appraisal Date'},
                    {value: {name: 'Card Signed', model: 'order', field: 'card_signed'}, text: 'Card Signed'},
//                    {value: {name: 'Date Created', model: 'order', field: 'orders.created_at'}, text: 'Date Created'},
                    {value: {name: 'Tracking Number', model: 'order.tracking_numbers', field: 'tracking_number'}, text: 'Tracking Number'},
                    {value: {name: 'Flag', model: 'order_flags', field: 'flag_type_id'}, text: 'Flag'},
                    {value: {name: 'Kit Request Date', model: 'order', field: 'created_at'}, text: 'Kit Request Date'},
                    {value: {name: 'Notes', model: 'order.notes', field: 'contents'}, text: 'Notes'},
                    {value: {name: 'Offer Ready Date', model: 'order', field: 'offer_generated_at'}, text: 'Offer Ready Date'},
                    {value: {name: 'Offer Total', model: 'pseudo_offer_total', field: 'total_offer'}, text: 'Offer Total'}, // May need to convert into a pseudo field, depending on if we calc the bonus value into this field
                    {value: {name: 'Total Value', model: 'order.offers', field: 'total_value'}, text: 'Total Value'},
                    {value: {name: 'Order ID', model: 'order', field: 'id'}, text: 'Order ID'},
                    {value: {name: 'Order Status', model: 'order', field: 'status_id'}, text: 'Order Status'},
                    {value: {name: 'Payment Process Date', model: 'order.payments', field: 'processed_at'}, text: 'Payment Process Date'},
                    {value: {name: 'Processed By', model: 'order', field: 'processor_id'}, text: 'Processed By'},
                    {value: {name: 'Receive Date', model: 'order', field: 'received_at'}, text: 'Receive Date'},
                    {value: {name: 'Settle Date', model: 'order', field: 'settled_at'}, text: 'Settle Date'},
                    {value: {name: 'Campaign By Name', model: 'order_sources', field: 'campaign_name'}, text: 'Campaign By Name'},
                    {value: {name: 'Campaign By Source', model: 'visitor_sources', field: 'source'}, text: 'Campaign By Source'},
                    {value: {name: 'Stop Workflow', model: 'order.flags', field: 'stop_workflow'}, text: 'Stop WorkFlow'},
                    {value: {name: 'Safe', model: 'inventory_management', field: 'location_id'}, text: 'Safe'},
                    {value: {name: 'Offer Email Sent', model: 'pseudo_offer_id', field: 'pseudo_offer_id'}, text: 'Offer Email Sent'},
                ],
                customer: [
                    //{value: {name: 'Account Manager', model: 'customer', field: 'users.id'}, text: 'Account Manager'}, // map to user id, add column in db
                    {value: {name: 'Address 1', model: 'customer.address', field: 'address1'}, text: 'Address 1'},
                    {value: {name: 'Address 2', model: 'customer.address', field: 'address2'}, text: 'Address 2'},
                    {value: {name: 'City', model: 'customer.address', field: 'city'}, text: 'City'},
                    {value: {name: 'Customer ID', model: 'customer', field: 'id'}, text: 'Customer ID'},
                    {value: {name: 'Customer Status', model: 'pseudo_customer_status', field: 'banned_at'}, text: 'Customer Status'},
                    {value: {name: 'Date Created', model: 'customer', field: 'created_at'}, text: 'Date Created'},
                    {value: {name: 'Email Address', model: 'customer', field: 'email'}, text: 'Email Address'},
                    {value: {name: 'First Name', model: 'customer', field: 'first_name'}, text: 'First Name'},
                    {value: {name: 'Flag', model: 'customer_flags', field: 'flag_type_id'}, text: 'Flag'},
                    //{value: {name: 'ID Number', model: 'customer', field: 'identity_number'}, text: 'ID Number'},
                    {value: {name: 'ID Type', model: 'customer', field: 'identity_type'}, text: 'ID Type'},
                    {value: {name: 'Last Name', model: 'customer', field: 'last_name'}, text: 'Last Name'},
                    {value: {name: 'Notes', model: 'customer.notes', field: 'contents'}, text: 'Notes'},
                    {value: {name: 'Phone Number', model: 'customer', field: 'phone'}, text: 'Phone Number'},
                    {value: {name: 'State', model: 'customer.address', field: 'state'}, text: 'State'},
                    {value: {name: 'Zip', model: 'customer.address', field: 'zip'}, text: 'Zip'},
                ],
                inventory: [
                    {value: {name: 'Appraisal Date', model: 'inventory', field: 'created_at'}, text: 'Appraisal Date'},
                    {value: {name: 'Clarity', model: 'inventory.inventory_components', field: 'clarity_id'}, text: 'Clarity', disabled: true},
                    {value: {name: 'Color', model: 'inventory.inventory_components', field: 'color_id'}, text: 'Color', disabled: true},
                    {value: {name: 'Contains Melee', model: 'pseudo_inventory_contains_melee', field: 'contains_melee'}, text: 'Contains Melee'},
                    /*{value: {name: 'Batch ID', model: 'batch_item', field: 'id'}, text: 'Fishbowl ID'},*/
                    {value: {name: 'Inventory ID', model: 'inventory', field: 'id'}, text: 'Inventory ID'},
                    {value: {name: 'Item Status', model: 'inventory', field: 'inventory_status_id'}, text: 'Item Status'},
                    {value: {name: 'Item Type', model: 'inventory', field: 'type_id'}, text: 'Item Type'},
                    {value: {name: 'Metal', model: 'inventory.inventory_components', field: 'class_id'}, text: 'Metal'},
                    {value: {name: 'Purity', model: 'inventory.inventory_components', field: 'purity'}, text: 'Purity', disabled: true},
                    {value: {name: 'Size', model: 'inventory', field: 'size'}, text: 'Size', disabled: true},
                    {value: {name: 'Total DWT', model: 'inventory', field: 'aggregate_dwt'}, text: 'Total DWT'},
                    {value: {name: 'Total Value', model: 'inventory.appraisals', field: 'total'}, text: 'Total Value'},
                ],
                returns: [
                    {value: {name: 'Return Date', model: 'order', field: 'returned_at'}, text: 'Return Date'},
                    {value: {name: 'Reverse Ship Date', model: 'reverseShipments', field: 'shipped_at'},text: 'Reverse Ship Date'},
                ],
            },

            table: {
                lastPage: null,
                itemsTo: null,
                itemsFrom: null,
                itemsTotal: null,
                itemsReturnedPerPage: null,
                nextPageUrl: null,
                prevPageUrl: null,
                refresh: false,
                allRowsSelected: false,
                selected: [],
                isBusy: false,
                editCurrentPage: false,
                customPage: this.currentPage,
                perPage: 30,
                currentPage: 1,
                tableView: 'simple',
                views: {
                    full: ['selected',
                        'outbound_method',
                        {key: 'id', label: 'order_id'},
                        'api_client',
                        {key: 'status_name', label: 'order status'},
                        'name',
                        'location',
                        'campaign',
                        {key: 'created_at', label: 'date requested', sortable: true},
                        {key: 'updated_at', label: 'last modified', sortable: true},
                        {key: 'received_at', label: 'date received', sortable: true},
                        {key: 'appraised_at', label: 'appraise date', sortable: true},

                        {key: 'total_value', label: 'AV', class: 'd-none', thClass: 'text-uppercase'},
                        {key: 'total_offer', label: 'Offer', class: 'd-none'},

                        'total_orders'
                    ],
                    simple: [
                        'selected',
                        {key: 'id', label: 'order_id'},
                        'customer_id',
                        'name',

                        {key: 'status_name', label: 'order status'},
                        {key: 'created_at', label: 'date requested', sortable: true},
                        {key: 'received_at', label: 'date received', sortable: true},
                        {key: 'appraised_at', label: 'appraise date', sortable: true},
                        {key: 'updated_at', label: 'last modified', sortable: true},
                        'total_orders'
                    ],
                }
            },
        };
    },
    beforeDestroy() {
        this.setMasterQuerySessionStorage();
    },
    created() {
        this.setupFilterStart();
        this.getResults();
        this.getData();
    },

    mounted() {
    },
    updated() {
        this.$nextTick(function () {
            var filtersWrapper = document.querySelector('.active-filters-height');
            filtersWrapper.scrollTop = filtersWrapper.scrollHeight;
        });
    },
    watch: {
        filterSelected: function () {
            if (this.filterSelected != null) {
                let filter = {
                    filterModel: this.filterSelected.model,
                    filterField: this.filterSelected.field,
                    filterName: this.filterSelected.name,
                    filterParameter: this.parameters(this.filterSelected.name),
                    filterValue: null,
                };
                this.$nextTick(() => {
                    // console.log("lets clear the filter");
                    this.filterSelected = null;
                });
                this.masterQuery.push(filter);
            }
        },
        currentPage: function () {
            this.currentPage = parseFloat(this.currentPage);
        },
        'table.perPage'() {
            this.table.currentPage = 1;
        },
        computedMasterQuery: {
            deep: true,
            handler(newVal, oldVal) {
                this.showDisabledFilters();
                if (Object.keys(newVal).length <= Object.keys(oldVal).length) {
                    this.getResults();
                }
                let that = this;
                for (const property in newVal) {
                    for (var prop in newVal[property]) {
                        let offer = that.table.views.full.find(item => item.key == 'total_offer');
                        let value = that.table.views.full.find(item => item.key == 'total_value');
                        if ( /*newVal[property].filterName == "Order Status" && newVal[property].filterValue == 8*/
                            this.findFilterByName('Offer Total').length
                            || this.findFilterByName('Offer Total').length
                            || this.findFilterByName('Accept Date').length
                            || this.findFilterByName('Decline Date').length
                            || this.findFilterByModel('order.offers').length
                            || _.filter(this.findFilterByName('Order Status'), (e) => {
                                return [8, 9, 10].includes(e.filterValue);
                            }).length
                        ) {
                            offer.class = null;
                            value.class = null;
                        } else {
                            //offer.class = 'd-none';
                            //value.class = 'd-none';
                            offer.class = null;
                            value.class = null;
                        }
                    }
                }
            }
        }
    },

    computed: {
        computedMasterQuery() {
            return Object.assign({}, this.masterQuery);
        },
        _itemRangeShown() {
            let end = this.table.perPage * this.table.currentPage;
            let start = end - (this.table.perPage - 1);
            if (end <= this.items.length) {
                return {
                    end: end,
                    start: start,
                };
            } else {
                return {
                    end: this.items.length,
                    start: start,
                };
            }
        },
        _newDataNeeded() {
            return this.items.length / this.table.perPage;
        },
        _lastPage() {
            return Math.ceil(this.table.itemsTotal / this.table.perPage);
        },
        _setFilterOptions() {
            switch (this.filterGroupSelected) {
                case 1:
                    return this.filterList.orders;
                case 2:
                    return this.filterList.customer;
                case 3:
                    return this.filterList.inventory;
                case 4:
                    return this.filterList.returns;
                default:
                    return this.filterList.orders;
            }
        },
        _tableFields() {
            return this.table.tableView === 'simple' ? this.table.views.simple : this.table.views.full;
        },
    },
    methods: {
        setMasterQuerySessionStorage() {
            sessionStorage.clear();
            sessionStorage.setItem('masterQuery', JSON.stringify(this.masterQuery));
        },
        goToKitsView(id) {
            let link = `/kit/view/${id}?search_filters=${this.hrefQueryPayload}`;
            if (this.$route.query.bid) {
                link = link + '?bid=' + this.$route.query.bid;
            }
            this.$router.push(link);
        },
        getData() {
            let that = this;
            this.$http.all([
                this.$store.dispatch('GET_REQUEST', '/items/classes'),
                //this.$http.get('/items/classes'),
                this.$http.get('/users'),
                this.$store.dispatch('GET_REQUEST', '/items/types'),
                this.$store.dispatch('GET_REQUEST', '/items/categories'),
                this.$store.dispatch('GET_REQUEST', '/items/clarities'),
                this.$store.dispatch('GET_REQUEST', '/flag-types'),
                this.$http.get('search/filter'),
            ]).then(this.$http.spread(function (classesResponse, usersResponse, itemTypesResponse, categoryResponse, clarityResponse, flagResponse, filterResponse) {
                that.itemClasses = classesResponse.data.data;
                that.users = usersResponse.data.data;
                that.itemTypes = itemTypesResponse.data.data;
                that.inventoryTypes = categoryResponse.data.data;
                that.itemClarities = clarityResponse.data.data;
                that.flagTypes = flagResponse.data.data;
                _.forEach(filterResponse.data.data, (e) => {
                    that.customFilters.push({id: e.id, name: e.name, config: JSON.parse(e.config), global: e.global});
                });
                that.$nextTick(() => {
                    that.loadingConfig = 4;
                    that.loadingFilter = false;
                    that.$forceUpdate();
                });
            }));
        },
        sendEmail() {
            this.sendingEmail = true;
            let order_ids = _.map(this.table.selected, (e) => {
                return e.id;
            });
            this.$http.post('/sendOfferEmail', {orders: order_ids}).then((e) => {
                this.refreshData();
            }).finally((e) => {
                this.sendingEmail = false;
            });
        },
        convertURIToJson() {
            let result = [];
            let checkGroups = ['filterField', 'filterModel', 'filterName', 'filterParameter', 'filterValue'];
            for (let j = 0; j < checkGroups.length; j++) {
                let i = 0;
                let loc = checkGroups[j];
                let index = loc + '_' + i;
                while (this.$route.query[index]) {
                    if (!result[i]) {
                        result[i] = {};
                    }
                    result[i][loc] = parseInt(this.$route.query[index]) || this.$route.query[index];

                    i++;
                    index = loc + '_' + i;
                }
            }
            return result;
        },
        findFilterByName(name) {
            return _.filter(this.masterQuery, (e) => {
                return e.filterName == name && e.filterValue != null;
            });
        },
        findFilterByModel(model) {
            return _.filter(this.masterQuery, (e) => {
                return e.filterModel == model && e.filterValue != null;
            });
        },
        findFilterFromQuery() {
            //todo load filters
            return this.customFilters[this.$route.params.filter];
        },
        getResults() {
            this.table.currentPage = 1;
            this.table.isBusy = true;
            let payload = _.reject(this.masterQuery, ['filterValue', null]);
            this.hrefQueryPayload = btoa(JSON.stringify(payload));


            if (typeof this.cancelToken != typeof undefined) {
                this.cancelToken.cancel('Operation canceled due to new request.');
            }
            this.cancelToken = this.$http.CancelToken.source();
            this.$http.post('/search/getResults', {query: payload}, {cancelToken: this.cancelToken.token}).then(response => {
                this.items = [];
                if (response.data.data.length > 0) {
                    this.items = response.data.data;
                }
                this.table.lastPage = response.data.last_page;
                this.table.itemsTotal = response.data.total;
                this.table.itemsFrom = response.data.from;
                this.table.itemsTo = response.data.to;
                this.table.itemsReturnedPerPage = response.data.per_page;
                this.table.nextPageUrl = response.data.next_page_url;
                this.table.prevPageUrl = response.data.prev_page_url;
                this.table.isBusy = false;
            });
        },
        checkIfItemTypeIsAFilter() {
            return this.masterQuery.some(item => item.filterName === 'Item Type');
        },
        checkIfMetalIsAFilter() {
            return this.masterQuery.some(item => item.filterName === 'Metal');
        },
        showDisabledFilters() {
            let clarityIndex = this.filterList.inventory.findIndex(item => item.text == 'Clarity');
            let colorIndex = this.filterList.inventory.findIndex(item => item.text == 'Color');
            let purityIndex = this.filterList.inventory.findIndex(item => item.text == 'Purity');
            let sizeIndex = this.filterList.inventory.findIndex(item => item.text == 'Size');

            if (this.checkIfItemTypeIsAFilter()) {
                // Clarity
                if (this.masterQuery.some(item => item.filterName === 'Item Type' && (item.filterValue === 33 || item.filterValue === 52))) {
                    this.filterList.inventory[clarityIndex].disabled = false;
                } else {
                    this.filterList.inventory[clarityIndex].disabled = true;
                }

                // Color
                if (this.masterQuery.some(item => item.filterName === 'Item Type' && (
                    item.filterValue === 33
                    || item.filterValue === 34
                    || item.filterValue === 35
                    || item.filterValue === 36
                    || item.filterValue === 37
                    || item.filterValue === 38
                    || item.filterValue === 39
                    || item.filterValue === 40
                    || item.filterValue === 41
                    || item.filterValue === 42
                    || item.filterValue === 43
                    || item.filterValue === 44
                    || item.filterValue === 45
                    || item.filterValue === 52
                ))) {
                    this.filterList.inventory[colorIndex].disabled = false;
                } else if (!this.checkIfMetalIsAFilter()) {
                    this.filterList.inventory[colorIndex].disabled = true;
                }

                // Size
                if (this.masterQuery.some(item => item.filterName === 'Item Type' && (item.filterValue === 1 || item.filterValue === 9 || item.filterValue === 12))) {
                    this.filterList.inventory[sizeIndex].disabled = false;
                } else {
                    this.filterList.inventory[sizeIndex].disabled = true;
                }
            } else {
                this.filterList.inventory[colorIndex].disabled = true;
                this.filterList.inventory[clarityIndex].disabled = true;
                this.filterList.inventory[sizeIndex].disabled = true;
            }
            if (this.checkIfMetalIsAFilter()) {
                if (this.checkIfItemTypeIsAFilter()) {
                    this.filterList.inventory[colorIndex].disabled = false;
                }
                this.filterList.inventory[purityIndex].disabled = false;
            } else {
                this.filterList.inventory[purityIndex].disabled = true;

                if (!this.masterQuery.some(item => item.filterName === 'Item Type' && (
                    item.filterValue === 33
                    || item.filterValue === 34
                    || item.filterValue === 35
                    || item.filterValue === 36
                    || item.filterValue === 37
                    || item.filterValue === 38
                    || item.filterValue === 39
                    || item.filterValue === 40
                    || item.filterValue === 41
                    || item.filterValue === 42
                    || item.filterValue === 43
                    || item.filterValue === 44
                    || item.filterValue === 45
                    || item.filterValue === 52
                ))) {
                    this.filterList.inventory[colorIndex].disabled = true;
                }
            }
            this.$forceUpdate();
        },
        refreshData() {
            this.table.refresh = true;
            this.getResults();
            this.$nextTick(function () {
                this.table.refresh = false;
            });
        },
        onRowSelected(items) {
            this.table.selected = items;
        },
        selectAllRows() {
            this.table.allRowsSelected = !this.table.allRowsSelected;
            this.$refs.resultsTable.selectAllRows();
        },
        clearSelected() {
            this.table.allRowsSelected = !this.table.allRowsSelected;
            this.$refs.resultsTable.clearSelected();
        },
        removeFilter(index) {
            this.masterQuery.splice(index, 1);
        },
        updateFilter(index, filter) {
            this.masterQuery[index] = filter;
        },
        clearFilters() {
            this.masterQuery = [];
//            this.setBaseFilters();
        },
        saveCustomFilters() {
            let filterData = JSON.parse(JSON.stringify(this.masterQuery));
            filterData.push({view: this.table.tableView});
            let payload = {
                name: this.customFilterName,
                config: JSON.stringify(filterData),
            };
            this.$http.post('/search/filter', payload).then((data) => {
                //saved
                let e = data.data.data;
                this.customFilters.push({id: e.id, name: e.name, config: JSON.parse(e.config)});
                this.$refs['saveFilterModal'].hide();
            });
            this.customFilterName = null;
        },
        deleteCustomFilter(filterToDelete) {
            this.$refs['deleteFilterModal'].hide();
            this.$http.delete('/search/filter/' + this.customFilters[filterToDelete].id).then((e) => {
                this.customFilters.splice(filterToDelete, 1);
                this.$forceUpdate();
            });
        },
        loadCustomFilter(value) {
            this.loadSavedFilter = true;
            this.masterQuery = [];
            this.$nextTick(function () {
                let newArrayDataOfOjbect = Object.values(value.config);
                // Remove "view" value from saved payload when setting master query
                this.masterQuery = JSON.parse(JSON.stringify(_.reject(newArrayDataOfOjbect, 'view')));
                this.$nextTick(function () {
                    this.loadSavedFilter = false;
                    if ( /*newVal[property].filterName == "Order Status" && newVal[property].filterValue == 8*/
                        this.findFilterByName('Offer Total').length
                        || this.findFilterByName('Offer Total').length
                        || this.findFilterByName('Accept Date').length
                        || this.findFilterByName('Decline Date').length
                        || this.findFilterByModel('order.offers').length
                        || _.filter(newArrayDataOfOjbect, ['view', 'full']).length
                    ) {
                        this.table.tableView = 'full';
                    } else {
                        this.table.tableView = 'simple';
                    }
                    this.refreshData();
                });
            });
        },
        openSaveFilterModal() {
            this.$refs['saveFilterModal'].show();
            let that = this;
            this.$nextTick(function () {
                this.$root.$on('bv::modal::shown', function () {
                    that.$refs['customFilterInput'].focus();
                });
            });
        },
        openDeleteFilterModal(filterToDelete) {
            this.customFilterToDelete = filterToDelete;
            this.$refs['deleteFilterModal'].show();
        },
        setupFilterStart() {
            this.masterQuery = JSON.parse(JSON.stringify(this.convertURIToJson()));
            if (this.masterQuery.length === 0) {
                if (sessionStorage.getItem('masterQuery') != null) {
                    let sessionFilters = JSON.parse(sessionStorage.masterQuery);
                    this.masterQuery = sessionFilters;
                } else {
                    this.setBaseFilters();
                }
            }
        },
        setBaseFilters() {
            this.masterQuery = JSON.parse(JSON.stringify(this.baseFilters));
        },
        enterCustomPage() {
            if (this.table.currentPage > this.tablePageLength) {
                alert('Amount Too High');
                this.table.currentPage = 1;
                this.table.editCurrentPage = !this.table.editCurrentPage;
            } else {
                this.table.editCurrentPage = !this.table.editCurrentPage;
            }
        },
        getNextData() {
            this.table.isBusy = true;
            let url = decodeURIComponent(this.table.nextPageUrl);
            this.$http.get(url).then(response => {
                this.items.push(...response.data.data);
                this.table.lastPage = response.data.last_page;
                this.table.itemsTotal = response.data.total;
                this.table.itemsFrom = response.data.from;
                this.table.itemsTo = response.data.to;
                this.table.itemsReturnedPerPage = response.data.per_page;
                this.table.nextPageUrl = response.data.next_page_url;
                this.table.isBusy = false;
            });
        },
        nextPage() {
            if (this.table.currentPage < this._newDataNeeded) {
                this.table.currentPage++;
            } else if (this.table.itemsTotal > this.items.length) {
                this.getNextData();
                this.table.currentPage++;
            }
        },
        prevPage() {
            if (this.table.currentPage > 1) {
                this.table.currentPage--;
            }
        },
        parameters(filterName) {
            switch (filterName) {
                case 'Date Created':
                case 'Payment Process Date':
                case 'Receive Date':
                case 'Kit Request Date':
                case 'Appraisal Date':
                case 'Offer Ready Date':
                case 'Accept Date':
                case 'Reverse Ship Date':
                case 'Settle Date':
                case 'Created On':
                case 'Return Date':
                    return 'on';
                case 'Notes':
                case 'Campaign By Name':
                case 'Campaign By Source':
                    return 'contains';
                case 'Zip':
                    return 'starts with';
                default:
                    return 'equals';
            }
        },
        download() {
            //asCSV
            this.downloadingCSV = true;
            let payload = _.reject(this.masterQuery, ['filterValue', null]);

            this.$http.post('/search/getResults?asCSV=1', {
                query: payload,
            },
            {
                responseType: 'blob',
            }).then((response) => {
                this.$http.downloadFile(response.data, 'Search' + Date.now() + '.csv');
            }).finally(() => {
                this.downloadingCSV = false;
            });
        }
    },
};
</script>

<style scoped>
.active-filters-height {
    height: 250px;
    overflow: scroll;
}
</style>
